var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.293 0.292999L0.585999 6L6.293 11.707L7.707 10.293L3.414 6L7.707 1.707L6.293 0.292999Z",
    fill: "#0086D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLeftArrow);
export default __webpack_public_path__ + "static/media/icons-left-arrow.6aa887395819db374611d20d86d00546.svg";
export { ForwardRef as ReactComponent };